/**
 * Discovery(홈) 계측 — 이벤트 이름과 속성의 정본.
 * @description 콜랩 상세의 `analytics.ts` 와 같은 방식이다. 이름은 "명사 + 과거분사" 한 벌로,
 *   속성은 위치(`placement`)와 순서(`index`)를 늘 싣는다 — 어느 줄의 몇 번째가 눌리는지가
 *   홈에서 가장 먼저 알고 싶은 것이다.
 */
import type { Banner, FanbaseItem } from "./dtos";
import type { CollabListItem } from "@/domains/core/collab";
import type { SpotlightItem } from "./components/DiscoverySpotlights/DiscoverySpotlights.types";
import { trackEvent } from "@/shared/lib/analytics/amplitude";

const PLACEMENT = {
  banner: "discovery-banner",
  collabs: "discovery-collabs",
  fanbases: "discovery-fanbases",
  spotlights: "discovery-spotlights",
} as const;

export function trackDiscoveryViewed(): void {
  trackEvent("Discovery Viewed");
}

export function trackBannerClicked(banner: Banner, index: number): void {
  trackEvent("Banner Clicked", {
    placement: PLACEMENT.banner,
    bannerId: banner.bannerId,
    title: banner.title,
    linkUrl: banner.linkUrl,
    index,
  });
}

export function trackDiscoveryCollabClicked(
  collab: CollabListItem,
  index: number,
): void {
  trackEvent("Collab Card Clicked", {
    placement: PLACEMENT.collabs,
    collabId: collab.collabId,
    collabTitle: collab.collabTitle,
    collabStatus: collab.collabStatus,
    collabType: collab.collabType,
    index,
  });
}

export function trackFanbaseCardClicked(
  fanbase: FanbaseItem,
  index: number,
): void {
  trackEvent("Fanbase Card Clicked", {
    placement: PLACEMENT.fanbases,
    fanbaseId: fanbase.fanbaseId,
    handle: fanbase.handle,
    index,
  });
}

export function trackFanbaseAppOpened(fanbase: FanbaseItem): void {
  trackEvent("Fanbase App Opened", {
    placement: PLACEMENT.fanbases,
    fanbaseId: fanbase.fanbaseId,
    handle: fanbase.handle,
  });
}

export function trackSpotlightClicked(
  item: SpotlightItem,
  index: number,
): void {
  trackEvent("Spotlight Clicked", {
    placement: PLACEMENT.spotlights,
    type: item.itemType,
    slug: item.slug,
    index,
  });
}

/** `page` 는 지금까지 받은 페이지 수 — 몇 장째에서 더 보기를 눌렀는지 */
export function trackSpotlightsLoadMore(page: number): void {
  trackEvent("Spotlights Load More Clicked", {
    placement: PLACEMENT.spotlights,
    page,
  });
}
